import { BoardingResourceForm } from "../BoardingResourceForm";

export const AddBoardingResource = () => {
  return <BoardingResourceForm />;
};
